module.exports = __webpack_public_path__ + "static/об аппарате 23.05.2016.docx";